import { render, staticRenderFns } from "./DeMinimisFileLogs.vue?vue&type=template&id=7649e6ce&"
import script from "./DeMinimisFileLogs.vue?vue&type=script&lang=js&"
export * from "./DeMinimisFileLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports